import React, { Component } from 'react'

import format from 'date-fns/format'
import { splitAndDedup } from 'utils/helpers'
import ConfirmModal from './Confirm'
import DenyModal from './Deny'

import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import Loader from 'components/Loader'
import InfiniteScroll from 'react-infinite-scroller'
import { Container, Header, Button, Table } from 'semantic-ui-react'

export class ConditionsSuggested extends Component {
  state = {
    limit: 50,
    offset: 0,
    hasMore: true,
  }

  renderRow = ({ id, name, userIds, created }) => {
    return (
      <Table.Row key={id}>
        <Table.Cell width={4}>{name}</Table.Cell>
        <Table.Cell>{splitAndDedup(userIds)}</Table.Cell>
        <Table.Cell>{format(created, 'MMM DD YYYY h:mm A')}</Table.Cell>
        <Table.Cell style={{ display: 'flex', position: 'relative' }}>
          <ConfirmModal condition={{ id, name }} />
          <DenyModal condition={{ id, name }} />
        </Table.Cell>
      </Table.Row>
    )
  }

  renderTable() {
    const { limit, offset, hasMore } = this.state
    const variables = { limit, offset }
    return (
      <Query query={SUGGESTED_CONDITIONS_QUERY} variables={variables}>
        {({ data, loading, fetchMore }) => {
          if (loading) {
            return <Loader />
          }

          return (
            <InfiniteScroll
              loadMore={() =>
                fetchMore({
                  variables: { offset: data.suggestedConditions.length },
                  updateQuery: (prev, { fetchMoreResult, variables }) => {
                    if (!fetchMoreResult) return prev
                    if (!fetchMoreResult.suggestedConditions.length) {
                      this.setState({ hasMore: false })
                    }
                    return {
                      ...prev,
                      suggestedConditions: [
                        ...prev.suggestedConditions,
                        ...fetchMoreResult.suggestedConditions,
                      ],
                    }
                  },
                })
              }
              hasMore={hasMore}
              loader={<Loader />}
            >
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>User ID</Table.HeaderCell>
                    <Table.HeaderCell>Date Suggested</Table.HeaderCell>
                    <Table.HeaderCell>Actions</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {data.suggestedConditions.map(this.renderRow)}
                </Table.Body>
              </Table>
            </InfiniteScroll>
          )
        }}
      </Query>
    )
  }

  render() {
    return (
      <Container>
        <Header as="h1">Suggested Conditions</Header>

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            primary
            onClick={() => this.props.history.push('/conditions')}
          >
            All Conditions
          </Button>
        </div>

        {this.renderTable()}
      </Container>
    )
  }
}

export const SUGGESTED_CONDITIONS_QUERY = gql`
  query SuggestedConditionsQuery($limit: Int, $offset: Int) {
    suggestedConditions(limit: $limit, offset: $offset) {
      id
      name
      userIds
      created
    }
  }
`

export default ConditionsSuggested
